import { AdvancedImage } from "@cloudinary/react";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useToastContext } from "../../../../contexts/ToastContext/ToastContext";
import useConfirmSearch from "../../../../hooks/useConfirmSearch";
import localeText from "../../../../locale";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import "../../../Shop/Shop.css";
import "./ProductCard.css";

import { Button } from "primereact/button";
import useProduct from "../../hooks/useProduct";
import { MiniAddToCart } from "./MiniAddToCart/MiniAddToCart";

const ProductCard = ({ product, mobileSection }) => {
  const { showErrorToast } = useToastContext();
  const { confirmSearch } = useConfirmSearch({
    productId: product?.id,
    onError: (code) => showErrorToast({ code }),
  });
  const {
    productInfo,
    loadingProductInfo,
    currentAttribute1Value,
    currentAttribute2Value,
    currentVariation,
    productQty,
  } = useProduct({ id: product?.id });

  const currencySymbols = {
    USD: "$",
    EUR: "€",
    BRL: "R$",
    GBP: "£",
    JPY: "¥",
    CNY: "¥",
    AUD: "AU$",
    CAD: "CA$",
    CHF: "CHF",
  };

  const discountPercentageCalculation = (normalPrice, promotionalPrice) => {
    const discountPercentage = ((normalPrice - promotionalPrice) / normalPrice) * 100;
    return discountPercentage.toFixed(0);
  };

  const currencySymbol = currencySymbols[product?.currency] || product?.currency;

  const cashback = product?.percentExtraCoin / 100;
  const cashbackValue =
    (product?.promotionalPriceUnique ? product?.promotionalPriceUnique : product?.priceUnique) *
    cashback;
  const promotionalNormalPrice = product?.promotionalPriceUnique
    ? product?.promotionalPriceUnique * PLATFORM_PRODUCT_FEE + product?.promotionalPriceUnique
    : null;

  const normalPrice = product?.priceUnique * PLATFORM_PRODUCT_FEE + product?.priceUnique;

  const freightType = product?.shippingOption;
  const freightText =
    freightType === "PICKUP"
      ? `${localeText("freight")} ${localeText("paid")}`
      : freightType === "FREESENDCLOUD"
      ? `${localeText("freight")} ${localeText("free")}`
      : freightType === "FREE"
      ? `${localeText("freight")} ${localeText("free")}`
      : `${localeText("freight")} ${localeText("paid")}`;

  if (!product) return null;
  return (
    <div
      key={`pdis${product.id}`}
      className="flex flex-column flex-wrap w-full relative surface-0  border-round-lg overflow-hidden gap-2 section-card-mobile"
    >
      <div
        className="flex justify-content-center cursor-pointer relative"
        onClick={() => confirmSearch()}
      >
        <AdvancedImage
          cldImg={cloudinaryInstance
            .image(product?.imageid1)
            .resize(fill().width(250).height(250))
            .format("webp")}
          className="productCardImg border-round-lg"
        />
      </div>
      <div
        onClick={() => confirmSearch()}
        title={product.title}
        className="text-sm font-medium overflow-hidden cursor-pointer"
        style={{
          color: "#245AE5",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          whiteSpace: "normal",
          overflow: "hidden",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          lineHeight: "1.25rem", // Example line height
          minHeight: "calc(1.25rem * 2)", // 2 lines height
        }}
      >
        {product?.title}
      </div>
      <div
        onClick={() => confirmSearch()}
        className="cursor-pointer"
        style={{ minHeight: "48px", height: "48px" }}
      >
        <div className="flex align-items-center justify-content-between w-full mb-2">
          {/*  */}
          {cashback > 0 && (
            <div className="font-medium" style={{ color: "#059669", fontSize: "10px" }}>
              Cashback {currencySymbol} {formatPrice(cashbackValue)}
            </div>
          )}
        </div>
        {promotionalNormalPrice && (
          <div className="font-bold text-lg" style={{ color: "#18181B" }}>
            <span className="text-sm font-normal mr-1" style={{ color: "#E02244" }}>
              -{discountPercentageCalculation(normalPrice, promotionalNormalPrice)}%
            </span>
            {currencySymbol} {formatPrice(promotionalNormalPrice)}
          </div>
        )}
        {!promotionalNormalPrice && (
          <div className="font-bold text-lg" style={{ color: "#18181B" }}>
            {currencySymbol} {formatPrice(normalPrice)}
          </div>
        )}
      </div>

      {!loadingProductInfo && (
        <div className="flex align-items-center justify-content-between">
          {!product?.downloadable && !product?.service && (
            <div>
              {!product?.downloadable && !product?.service && (
                <div className="flex align-items-center" style={{ color: "#344563" }}>
                  <>
                    {!product?.downloadable && !product?.service && (
                      <div className={`lg:text-sm text-xs flex align-items-start gap-1 `}>
                        <i className={`pi pi-truck `} /> {`${freightText}`}
                      </div>
                    )}
                  </>
                </div>
              )}
            </div>
          )}

          <MiniAddToCart
            productCardMobile={true}
            productInfo={productInfo}
            currentVariation={currentVariation}
            currentAttribute1Value={currentAttribute1Value}
            currentAttribute2Value={currentAttribute2Value}
            productQty={productQty}
          />
        </div>
      )}
    </div>
  );
};

export default ProductCard;
